import ApiDatastoreHandler from './ApiDatastoreHandler'
import DatastoreTypeHandler from './DatastoreTypeHandler'
import PdfDatastoreHandler from './PdfDatastoreHandler'
import ShapefileDatastoreHandler from './ShapefileDatastoreHandler'
import TifDatastoreHandler from './TifDatastoreHandler'

const HANDLER_MAP = {
  shapefile: ShapefileDatastoreHandler,
  tif: TifDatastoreHandler,
  pdf: PdfDatastoreHandler,
  api: ApiDatastoreHandler,
}

const instances = {}

export function createDatastoreTypeHandler(type) {
  const key = type || 'unknown'
  if (!instances[key]) {
    const Handler = HANDLER_MAP[key]
    instances[key] = Handler
      ? new Handler()
      : new DatastoreTypeHandler(type)
  }
  return instances[key]
}

export function resetDatastoreTypeHandlers() {
  Object.keys(instances).forEach((key) => {
    delete instances[key]
  })
}
